/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BedAllotment from './bed-allotment';
import BedAllotmentDetail from './bed-allotment-detail';
import BedAllotmentUpdate from './bed-allotment-update';
import BedAllotmentDeleteDialog from './bed-allotment-delete-dialog';

const BedAllotmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BedAllotment />} />
    <Route path="new" element={<BedAllotmentUpdate />} />
    <Route path=":id">
      <Route index element={<BedAllotmentDetail />} />
      <Route path="edit" element={<BedAllotmentUpdate />} />
      <Route path="delete" element={<BedAllotmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BedAllotmentRoutes;
